import { RangeStyle } from "./data";

// @dynamic
export class LegendUtils {
  static getLabels(range: RangeStyle<any>, digits?: number, units?:string): string[] {
    if((digits===null)||(digits===undefined)){
    let max = range.breakpoints[range.breakpoints.length-1] || range.breakpoints[range.breakpoints.length-2];
    max = Math.max(max,0.1);
    digits = Math.max(0.0,2 - +Math.log10(max).toFixed());
    }

    const fmt = (v: number) => v.toFixed(digits || 0);
    let formattedValues = range.breakpoints.map(b=>b===null?null:fmt(b));
    if(formattedValues.filter(v=>v!==null).every(v=>v.match(/\.0+$/))){
    formattedValues = formattedValues.map(v=>v?.replace(/\.0+$/,''));
    }
    let result = range.breakpoints.map((b, i) => {
    const nextB = range.breakpoints[i + 1];
    if((b===null) && (i===0)){
        return `< ${formattedValues[i + 1]}`;
    }
    if(nextB===null){
        return `> ${formattedValues[i]}`;
    }
    if (i < (range.breakpoints.length - 1)) {
        return `${formattedValues[i]}-${formattedValues[i+1]}`;
    }
    return null;
    }).filter(l => !!l);

    if(units){
      result = result.map(l => `${l} ${units}`);
    }

    return result.reverse();
  }
}